import axios from 'axios';

const axiosClient = axios.create({
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    }
});

axiosClient.interceptors.response.use(
    function (response) {
        return response.data;
    },
    function (error) {
        let res = error.response;

        //code-based error actions here
        switch (res.status) {
            case '401':
                console.log('unauthorized');
        }
        alert(res.data.errors.join('\n'));
        console.error("Looks like there was a problem. Status Code: " + res.status);
        return Promise.reject(res.data.message);
    }
);

export default axiosClient